type TimeUnit = 'month' | 'week' | 'day' | 'hour' | 'minute' | 'second';

const addTime = (date: Date, value: number, unit: TimeUnit) => {
  const result = new Date(date);

  switch (unit) {
    case 'month':
      result.setMonth(result.getMonth() + value);
      break;
    case 'week':
      result.setDate(result.getDate() + value * 7);
      break;
    case 'day':
      result.setDate(result.getDate() + value);
      break;
    case 'hour':
      result.setHours(result.getHours() + value);
      break;
    case 'minute':
      result.setMinutes(result.getMinutes() + value);
      break;
    case 'second':
      result.setSeconds(result.getSeconds() + value);
      break;
  }

  return result;
};

export const getRemainingDateUTC = ({
  unit = 'week',
  date,
  value = 1,
}: {
  unit: TimeUnit;
  date?: string;
  value: number;
}): string => {
  const baseDate = date ? new Date(date) : new Date();
  if (date) return baseDate.toUTCString();

  const updatedDate = addTime(baseDate, value, unit);

  return updatedDate.toUTCString();
};
